module.exports = __webpack_public_path__ + "static/media/search.0d17aabd.svg";